import { useState } from 'react'
import { useIsMobileDevice } from 'hooks/useIsMobileDevice'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { useScreenSizeOnly } from 'hooks/useScreenSize'

/**
 * Keep SSR and the first client render consistent using the request's device.
 * After mounting, use the mobile viewport breakpoint, including on resize.
 */
export function useIsMobileWithSsrFallback(): boolean {
  const isMobileDevice = useIsMobileDevice()
  const isMobileViewport = useScreenSizeOnly('mobile')
  const [hasMounted, setHasMounted] = useState(false)

  useIsomorphicLayoutEffect(() => {
    setHasMounted(true)
  }, [])

  return hasMounted ? isMobileViewport : isMobileDevice
}
